// extracted by mini-css-extract-plugin
export var subtitle = "_a3-2";
export var title = "_a3-0";
export var titleNoWrap = "_a3-1";